import { Users } from 'lucide-react';
import { TEAM } from './landingData';

const initials = (name) => name.replace(/\(.*?\)/g, '').split(' ').filter(Boolean).map(p => p[0]).slice(0, 2).join('');

export const TeamSection = () => (
  <section id="team" className="py-20 sm:py-28 px-6 sm:px-10 bg-white" data-testid="team-section">
    <div className="max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
        <div className="lg:col-span-7">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#F26522] font-semibold mb-4 flex items-center gap-2"><Users className="w-4 h-4" /> Meet the team</p>
          <h2 className="text-3xl sm:text-4xl font-black text-[#3E2418] tracking-tight leading-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>
            The people behind Elmwood.
          </h2>
        </div>
        <p className="lg:col-span-5 text-slate-600 leading-relaxed text-base">
          An owner-operator group that is in the restaurants every week — backed by store managers and 220+ team members across Atlantic Canada.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 stagger" data-testid="team-grid">
        {TEAM.map((m, i) => (
          <article key={m.name} className="group relative rounded-2xl border border-slate-200 bg-[#FDFBF7] p-6 flex gap-5 hover:-translate-y-1 hover:shadow-xl transition-all duration-300" data-testid={`team-member-${i}`}>
            {m.photo ? (
              <img src={m.photo} alt={m.name} className="w-16 h-16 rounded-2xl object-cover shadow-md flex-shrink-0" />
            ) : (
              <div className="w-16 h-16 rounded-2xl bg-[#3E2418] text-white flex items-center justify-center text-xl font-black shadow-md group-hover:bg-[#F26522] transition-colors flex-shrink-0" style={{ fontFamily: 'Chivo, sans-serif' }}>
                {initials(m.name)}
              </div>
            )}
            <div className="min-w-0">
              <h3 className="font-bold text-[#3E2418] text-base leading-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>{m.name}</h3>
              <p className="text-[11px] uppercase tracking-wider text-[#F26522] font-semibold mt-1">{m.title}</p>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{m.blurb}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
